<template>
  <div class="recordData-time" id="recordtitle">
    <!-- <sidebar @event="formChild"></sidebar> -->
    <div class="lowerview">
      <div class="centerview">
        <el-row>
          <el-col :span="21">
            <ul>
              <!-- 预付类型时显示省份、城市、场站选择框 -->
              <li v-if="payment_type !== 'wallet'">
                <el-select
                  style="width: 120px"
                  v-model="province_value"
                  clearable
                  placeholder="请选择省份"
                  @change="getcitys(province_value)"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.province"
                    :label="item.province"
                    :value="item.province"
                  ></el-option>
                </el-select>
              </li>
              <li v-if="payment_type !== 'wallet'">
                <el-select
                  v-model="city_value"
                  clearable
                  style="width: 120px"
                  placeholder="请选择城市"
                  @change="getStations(city_value)"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.city"
                    :label="item.city"
                    :value="item.city"
                  ></el-option>
                </el-select>
              </li>
              <li v-if="payment_type !== 'wallet'">
                <el-select
                  v-model="station_value"
                  clearable
                  style="width: 120px"
                  placeholder="请选择场站"
                >
                  <el-option
                    v-for="item in stationList"
                    :key="item.station_id"
                    :label="item.station_name"
                    :value="item.station_id"
                  ></el-option>
                </el-select>
              </li>
              
              <!-- 钱包类型时将流水号、手机号输入框放到开始时间前面 -->
              <li v-if="payment_type === 'wallet'" class="search-inputs-row">
                <div class="input-group">
                  <el-input
                    placeholder="请输入交易流水号"
                    v-model="orderid_input"
                    clearable
                    style="width: 200px; margin-right: 10px;"
                  ></el-input>
                  <el-input
                    placeholder="请输入用户手机号"
                    v-model="Phone_input"
                    clearable
                    style="width: 200px;"
                  ></el-input>
                </div>
              </li>
            
              <li>
                <el-date-picker
                  v-model="statrttime_value"
                  type="datetime"
                  style="width: 200px"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择开始时间"
                ></el-date-picker>
              </li>
              <li>
                <el-date-picker
                  v-model="endtime_value"
                  type="datetime"
                  placeholder="请选择结束时间"
                  style="width: 200px"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </li>

              <!-- 类型选择框 - 移动到结束时间后面 -->
              <li>
                <el-select
                  v-model="payment_type"
                  style="width: 120px"
                  placeholder="请选择类型"
                  @change="handlePaymentTypeChange"
                >
                  <el-option
                    v-for="item in paymentTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>

              <!-- 钱包类型时隐藏支付状态选择框 -->
              <li v-if="payment_type !== 'wallet'">
                <el-select
                  v-model="status_input"
                  clearable
                  style="width: 120px"
                  placeholder="支付状态"
                >
                  <el-option
                    v-for="(value, key) in statusMap"
                    :key="key"
                    :label="value"
                    :value="key"
                  ></el-option>
                </el-select>
              </li>

              <!-- 预付类型时显示流水号、手机号输入框 -->
              <li v-if="payment_type !== 'wallet'" class="search-inputs-row">
                <div class="input-group">
                  <el-input
                    placeholder="请输入交易流水号"
                    v-model="orderid_input"
                    clearable
                    style="width: 200px; margin-right: 10px;"
                  ></el-input>
                  <el-input
                    placeholder="请输入用户手机号"
                    v-model="Phone_input"
                    clearable
                    style="width: 200px;"
                  ></el-input>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :span="3">
            <!-- <div class="centerrightview"> -->
            <ul>
              <li>
                <el-button
                  type="primary"
                  class="querybutton search"
                  @click="querybtnClick()"
                  >查询</el-button
                >
              </li>
              
            </ul>
            <!-- </div> -->
          </el-col>
        </el-row>
      </div>
      <div class="bottomviewtwo">
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%"
        >
          <!-- 钱包类型时隐藏场站列 -->
          <el-table-column
            v-if="payment_type !== 'wallet'"
            align="left"
            prop="station_name"
            label="场站"
            :show-overflow-tooltip="true"
            width="180"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="phone_number"
            label="手机号"
            :show-overflow-tooltip="true"
            width="100"
          ></el-table-column>
          
          <!-- 将openid字段列移动到手机号后面 -->
          <el-table-column
            align="left"
            prop="openid"
            label="OpenID"
            width="232"
          ></el-table-column>
          
          <el-table-column
            align="left"
            prop="request_num"
            label="交易流水号"
            :show-overflow-tooltip="true"
            width="180"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="amount"
            label="充值金额"
            :formatter="formatAmount"
          ></el-table-column>
          
          <!-- 钱包类型时隐藏支付状态列 -->
          <el-table-column
            v-if="payment_type !== 'wallet'"
            align="left"
            prop="status"
            label="支付状态"
            :formatter="formatStatus"
          ></el-table-column>
          
          <el-table-column
            align="left"
            prop="paytime"
            label="支付时间"
            :show-overflow-tooltip="true"
            width="180"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="refundamount"
            label="退款金额"
            :formatter="formatRefundAmount"
          ></el-table-column>
          <el-table-column
            align="left"
            prop="refundtime"
            label="退款时间"
            :show-overflow-tooltip="true"
            width="180"
          ></el-table-column>

          <!-- 钱包类型时隐藏操作列 -->
          <el-table-column v-if="payment_type !== 'wallet'" label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="refund(scope.row.request_num, scope.row.refundamount, scope.row.status, scope.row.amount)"
              >退款</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="cutpagesview">
        <el-pagination
          class="pageinclass"
          background
          :page-size="pagesize"
          :page-count="pagecount"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="prev, pager, next,jumper"
          :total="total"
        ></el-pagination>
      </div>
      
      <!-- 退款对话框 -->
      <el-dialog
        title="退款操作"
        :visible.sync="refundDialogVisible"
        width="420px"
        center
        :close-on-click-modal="false"
        class="refund-dialog"
      >
        <div class="refund-dialog-content">
          <div class="amount-info">
            <i class="el-icon-wallet"></i>
            <span class="amount-label">充值金额：</span>
            <span class="amount-value">¥{{ currentRefundData ? currentRefundData.amount : '0.00' }}</span>
          </div>
          
          <div class="refund-options">
            <div class="option-title">请选择退款方式：</div>
            
            <el-radio-group v-model="refundType" class="refund-radio-group">
              <el-radio label="full" class="refund-option">
                <div class="option-content">
                  <i class="el-icon-goods"></i>
                  <div class="option-text">
                    <div class="option-main">全额退款</div>
                    <div class="option-desc">¥{{ currentRefundData ? currentRefundData.amount : '0.00' }}</div>
                  </div>
                </div>
              </el-radio>
              
              <el-radio label="custom" class="refund-option">
                <div class="option-content">
                  <i class="el-icon-edit"></i>
                  <div class="option-text">
                    <div class="option-main">自定义退款金额</div>
                    <div v-if="refundType === 'custom'" class="custom-input-section">
                      <el-input
                        v-model="customAmount"
                        placeholder="请输入金额"
                        size="small"
                        class="custom-amount-input"
                        @input="validateCustomAmount"
                        @blur="validateCustomAmount"
                      >
                        <template slot="prepend">¥</template>
                      </el-input>
                      <div v-if="customAmountError" class="error-tip">{{ customAmountError }}</div>
                      <div v-else class="hint-tip">可退款范围：0 - {{ currentRefundData ? currentRefundData.amount : '0.00' }}</div>
                    </div>
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleRefundCancel" size="small">取 消</el-button>
          <el-button 
            type="primary" 
            @click="handleRefundConfirm"
            :disabled="refundType === 'custom' && !isValidCustomAmount"
            size="small"
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
      
      <!-- 退款失败重试对话框 -->
      <el-dialog
        title="退款失败重试"
        :visible.sync="refundFailedDialogVisible"
        width="480px"
        center
        :close-on-click-modal="false"
        class="refund-failed-dialog"
      >
        <div class="refund-failed-content">
          <div class="warning-header">
            <div class="warning-icon-text">
              <i class="el-icon-warning warning-icon"></i>
              <div class="warning-main">
                <div class="warning-title">退款失败记录</div>
                <div class="warning-desc">检测到该笔交易之前退款失败，是否重新尝试退款？</div>
              </div>
            </div>
          </div>
          
          <div class="transaction-info">
            <div class="info-section-title">
              <i class="el-icon-document info-icon"></i>
              <span>交易信息</span>
            </div>
            <div class="info-items">
              <div class="info-item">
                <span class="info-label">交易流水号：</span>
                <span class="info-value">{{ currentData ? currentData.request_num : '' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">充值金额：</span>
                <span class="info-value">¥{{ currentData ? currentData.amount : '0.00' }}</span>
              </div>
              <div v-if="currentData && currentData.refundamount" class="info-item">
                <span class="info-label">上次退款金额：</span>
                <span class="info-value">¥{{ currentData.refundamount }}</span>
              </div>
            </div>
          </div>
          
          <div class="retry-tip">
            <i class="el-icon-info tip-icon"></i>
            <span class="tip-text">重新退款将使用上次的退款金额进行重试</span>
          </div>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleRefundFailedCancel" size="small">取 消</el-button>
          <el-button 
            type="primary" 
            @click="handleRefundFailedRetry"
            size="small"
          >
            重新退款
          </el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { transformStringTime } from "../../filters/index.js";
import { constants } from "fs";
import sidebar from "../sidebar";
import API_ROOT from "../../../config/dev.env";

export default {
  name: "RechargeRecordData",
  components: {
    sidebar,
  },
  data() {
    return {
      linkurl: "", //下载链接
      total: 10, //这个是总共有多少条数据
      pagesize: 10, //每页显示条目个数
      currentPage: 1, //当前页数
      pagecount: 10, //页码按钮的数量
      province_value: "", //选择省份
      city_value: "", //选择城市
      provinceList: [], //省份列表
      cityList: [], //城市列表
      stationList: [], //场站列表
      statistics: [], //合计数据
      station_value: "", //选择场站
      statrttime_value: "", //选择开始时间
      endtime_value: "", //选择结束时间
      orderid_input: "", //交易流水号
      Phone_input: "", //用户手机号码
      payment_type: "prepay", //支付类型，默认预付
      paymentTypeList: [
        { value: "prepay", label: "预付" },
        { value: "wallet", label: "钱包" }
      ], //支付类型列表
      status_input: "", //支付状态

      tableData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.start_date || time.getTime() > Date.now()
          );
        },
      },
      exportPrivilege: 1, //导出
      
      // 添加状态映射
      statusMap: {
        2: '已支付',
        3: '已退款', 
        4: '无需退款',
        5: '退款失败'
      },
      
      // 添加退款相关数据
      refundDialogVisible: false,
      refundFailedDialogVisible: false,  // 新增：退款失败重试对话框
      refundType: 'full',
      customAmount: '',
      currentRefundData: null,
      currentData: null,
      customAmountError: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    window.document
      .querySelector("body")
      .setAttribute("style", "background-color:#f8f8f8");
    window.document
      .querySelector("body")
      .setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#efefef";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },

  mounted() {
    let role = [];
    role = this.$store.state.role;
    for (let i in role) {
      if (role[i].view_name == "充电管理") {
        for (let j in role[i].chlid) {
          if (role[i].chlid[j].view_name == "充电记录") {
            for (let m in role[i].chlid[j].method) {
              if (role[i].chlid[j].method[m].method_name == "导出") {
                this.exportPrivilege = 0;
              }
            }
          }
        }
      }
    }

    this.$nextTick(function () {
      this.defaultTime();
      this.getprovinces();
      this.querybtnClick();
    });
  },

  methods: {
    // 新增：处理支付类型切换
    handlePaymentTypeChange(newType) {
      // 重置搜索条件
      this.resetSearchConditions();
      
      // 自动刷新数据
      this.currentPage = 1;
      this.querybtnClick();
    },
    
    // 新增：重置搜索条件
    resetSearchConditions() {
      // 重置省份、城市、场站选择
      if (this.payment_type === 'wallet') {
        this.province_value = '';
        this.city_value = '';
        this.station_value = '';
        this.cityList = [];
        this.stationList = [];
      }
      
      // 重置支付状态
      this.status_input = '';
      
      // 重置其他搜索条件
      this.orderid_input = '';
      this.Phone_input = '';
    },
    
    defaultTime() {
      // var timestamp = new Date().getTime(); //毫秒
      // timestamp = timestamp - 1 * 24 * 3600 * 1000;
      var d = new Date();

      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth() + 1) +
        "-" +
        this.checkTime(d.getDate()) +
        " 00:00:00";

      this.statrttime_value = start_date;

      this.start_date = start_date;

      var d1 = new Date();
      let end_date = d1.getFullYear() + "-" + this.checkTime(d1.getMonth() + 1) + "-" + this.checkTime(d1.getDate()) + " " + this.checkTime(d1.getHours()) + ":" + this.checkTime(d1.getMinutes()) + ":" + this.checkTime(d1.getSeconds());

      this.endtime_value = end_date;
    },
    /**
     * 导出调用方法
     */
    createAndDownloadFile(content) {
      let link = document.createElement("a");
      let contentArr = content.split("/");
      contentArr[0] = JSON.parse(API_ROOT.API_ROOT);
      content =
        contentArr[0] +
        "/" +
        contentArr[1] +
        "/" +
        contentArr[2] +
        "/" +
        contentArr[3];

      link.href = content;
      link.click();
    },

    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.currentPage = val;
      var value = String(val);
      this.querybtnClick(value);
    },
    /**
       * 获取省份数据列表
       */
       getprovinces() {
        let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
        };
        this.$api({
          method: "post",
          url: "/api.php/Currency/get_provinces",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            if (su.data.code == 1) {
              this.provinceList = su.data.list;
            } else if (su.data.code == 0) {
              this.$message.warning(su.data.message);
            } else if (su.data.code == 300) {
              localStorage.clear();
              this.$router.push("/login");
              this.$message.warning(su.data.message);
            }
          })
          .catch((err) => {});
      },
      /**
       * 获取城市列表
       */
      getcitys(province_value) {
        this.city_value = "";
        this.cityList = [];
        this.stationList = [];
        this.station_value = "";
        let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          province: province_value,
        };
        this.$api({
          method: "post",
          url: "/api.php/Currency/get_citys",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            if (su.data.code == 1) {
              this.cityList = su.data.list;
            } else if (su.data.code == 0) {
              this.$message.warning(su.data.message);
            } else if (su.data.code == 300) {
              localStorage.clear();
              this.$router.push("/login");
              this.$message.warning(su.data.message);
            }
          })
          .catch((err) => {});
      },
  
      /**
       * 获取场站列表
       */
      getStations(city_value) {
        this.station_value = "";
        this.stationList = [];
        this.chargerlist = [];
  
        let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          city: city_value,
        };
  
        this.$api({
method: "post",
          url: "/api.php/Currency/get_stations",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            if (su.data.code == 1) {
              this.stationList = su.data.list;
            } else if (su.data.code == 300) {
              // 登录态过期;
              localStorage.clear();
              this.$router.push("/login");
              this.$message.warning(su.data.message);
            } else if (su.data.code == 302) {
              //数据库出错,查询失败
              this.$message.warning(su.data.message);
            } else if (su.data.code == 303) {
              //暂时没有场站数据
              this.$message.warning(su.data.message);
            }
          })
          .catch((err) => {});
      },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    /**
     * 格式化金额显示
     */
    formatAmount(row, column, cellValue) {
      return cellValue ? '¥' + parseFloat(cellValue).toFixed(2) : '¥0.00';
    },
    
    /**
     * 格式化退款金额显示 - 当退款金额为0时显示为空
     */
    formatRefundAmount(row, column, cellValue) {
      return cellValue && parseFloat(cellValue) > 0 ? '¥' + parseFloat(cellValue).toFixed(2) : '';
    },
    
    /**
     * 格式化状态显示
     */
    formatStatus(row, column, cellValue) {
      return this.statusMap[cellValue] || '未知状态';
    },
    
    /**
     * 获取筛选信息列表
     */
    querybtnClick(page) {
      this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getPaymentRecord"
      };
      if (page != "" && page != null) {
        params.page = page;
      }
      if (this.province_value != "") {
        params.province = this.province_value;
      }
      if (this.city_value != "") {
        params.city = this.city_value;
      }
      if (this.station_value != "") {
        params.station_id = this.station_value;
      }
      if (this.payment_type != "") {
        params.payment_type = this.payment_type;
      }
      
      if (this.statrttime_value != "" && this.statrttime_value != null) {
        params.start_time = this.statrttime_value;
        params.end_time = this.endtime_value;
      }

      if (this.status_input != "") {
        params.status = this.status_input;
      }

      if (this.orderid_input != "") {
        params.request_num = this.orderid_input;
      }

      if (this.Phone_input != "") {
        params.phone_number = this.Phone_input;
      }


      if (this.statrttime_value > this.endtime_value) {
        this.$message.warning("结束日期时间不能小于开始日期时间");
      } else {
        this.$api({
          method: "post",
          url: "/api.php/paymentRecord/index",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            if (su.data.code == 1) {
              let datalist = su.data.data;
              this.statistics = su.data;
              
              // 直接使用后端返回的数据，无需额外处理
              this.tableData = datalist;

              if (page == "" || page == null) {
                this.currentPage = 1;
                this.total = parseInt(su.data._count);
                this.pagecount = su.data.page_count;
              }
            } else if (su.data.code == 300) {
              localStorage.clear();
              this.$router.push("/login");
              this.$message.warning(su.data.message);
            } else if (su.data.code == 302) {
              this.$message.warning("查询失败");
            } else if (su.data.code == 303) {
              this.total = 0;
              this.pagecount = 1;
              this.$message.error("查询月份不能横跨超过一个月");
            } else if (su.data.code == 304) {
              this.total = 0;
              this.pagecount = 1;
              this.$message.warning("未查询到所需记录");
            } else {
              this.handleAuditError(su.data.message || '系统错误');
            }
          })
          .catch((err) => {});
      }
    },

    handleAuditError(message) {
      this.auditLoading = false;
      this.$message.error(message);
    },
    
    /**
     * 合计所有页数据 
     */
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      const backendData = this.statistics;

      columns.forEach((col, index) => {
        if (index === 0) {
          sums[index] = '总合计';
          return;
        }

        // 处理金额字段的合计
        if (col.property === 'amount') {
          const totalAmount = backendData.amount || 0;
          sums[index] = '¥' + parseFloat(totalAmount).toFixed(2);
        } else if (col.property === 'refundamount') {
          const totalRefund = backendData.refundAmount || 0;
          sums[index] = '¥' + parseFloat(totalRefund).toFixed(2);
        } else {
          sums[index] = ''; // 其他字段不显示合计
        }
      });

      return sums;
    },
 
    /**
     * 退款操作
     */
    refund(request_num, refundamount, status, amount) {
      // 状态2（已支付）时，需要选择退款方式
      if (status == 2) {
        // 保存当前退款数据
        this.currentRefundData = {
          request_num,
          refundamount,
          status,
          amount
        };
        
        // 重置退款类型和自定义金额
        this.refundType = 'full';
        this.customAmount = amount;
        this.customAmountError = '';
        
        // 显示退款对话框
        this.refundDialogVisible = true;
      } 
      // 状态5（退款失败）时，显示退款失败重试提示框
      else if (status == 5) {

        // 渲染当前退款数据
        this.currentData = {
          request_num,
          refundamount,
          status,
          amount
        };
        
        this.currentRefundData = {
          request_num,
          status
        };
        
        // 显示退款失败重试对话框
        this.refundFailedDialogVisible = true;
      } 
      else {
        // 其他状态直接退款，不需要选择金额
        this.executeRefund(request_num, refundamount, status);
      }
    },

     /**
     * 处理退款失败重试
     */
     handleRefundFailedRetry() {
      if (!this.currentRefundData) return;
      
      const { request_num, status } = this.currentRefundData;
      
      // 状态5（退款失败）重试时，不传递退款金额参数
      this.executeRefund(request_num, '', status);
      this.refundFailedDialogVisible = false;
    },
    
    /**
     * 处理退款失败取消
     */
    handleRefundFailedCancel() {
      this.refundFailedDialogVisible = false;
      this.$message.info('已取消退款重试操作');
    },
    
    /**
     * 验证自定义金额
     */
    validateCustomAmount() {
      this.customAmountError = '';
      
      if (!this.customAmount) {
        return;
      }
      
      // 检查是否为有效数字
      if (!/^\d+(\.\d{1,2})?$/.test(this.customAmount)) {
        this.customAmountError = '请输入有效的金额（最多两位小数）';
        return;
      }
      
      const customAmountNum = parseFloat(this.customAmount);
      const maxAmount = parseFloat(this.currentRefundData.amount);
      
      if (customAmountNum <= 0) {
        this.customAmountError = '退款金额必须大于0';
      } else if (customAmountNum > maxAmount) {
        this.customAmountError = '退款金额不能超过充值金额';
      }
    },
    
    /**
     * 检查自定义金额是否有效
     */
    isValidCustomAmount() {
      if (this.refundType !== 'custom') return true;
      
      if (!this.customAmount) {
        return false;
      }
      
      if (!/^\d+(\.\d{1,2})?$/.test(this.customAmount)) {
        return false;
      }
      
      const customAmountNum = parseFloat(this.customAmount);
      const maxAmount = parseFloat(this.currentRefundData.amount);
      
      return customAmountNum > 0 && customAmountNum <= maxAmount;
    },
    
    /**
     * 处理退款确认
     */
    handleRefundConfirm() {
      if (!this.currentRefundData) return;
      
      const { request_num, status } = this.currentRefundData;
      let refundAmount = '';
      
      if (this.refundType === 'full') {
        // 全额退款
        refundAmount = this.currentRefundData.amount;
      } else {
        // 自定义金额
        if (!this.isValidCustomAmount) {
          this.$message.error('请输入有效的退款金额');
          return;
        }
        refundAmount = this.customAmount;
      }
      
      // 执行退款
      this.executeRefund(request_num, refundAmount, status);
      this.refundDialogVisible = false;
    },
    
    /**
     * 处理退款取消
     */
    handleRefundCancel() {
      this.refundDialogVisible = false;
      this.$message.info('已取消退款操作');
    },

    /**
     * 执行退款API调用
     */
    executeRefund(request_num, refundamount, status) {
      // 组装参数
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "refund",
        request_num: request_num,
        status: status
      };

      // 当status为2（已支付）时，必须传递refundamount
      if (status == 2) {
        if (!refundamount) {
          this.$message.error('已支付状态的退款必须指定退款金额');
          return;
        }
        params.refundamount = refundamount;
      }
      // 其他状态不传递refundamount参数

      this.$api({
        method: "post",
        url: "/api.php/paymentRecord/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success('退款成功');
            // 刷新数据
            this.querybtnClick();
          } else {
            this.$message.error(su.data.message || '退款失败');
          }
        })
        .catch((err) => {
          this.$message.error('退款请求失败');
        });
    },

    /**
     * 导出数据csv
     */
    exportbtnClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };

      if (this.province_value != "") {
        params.province = this.province_value;
      }
      if (this.city_value != "") {
        params.city = this.city_value;
      }
      if (this.station_value != "") {
        params.station_id = this.station_value;
        var stationname = "";
        for (var i = 0; i < this.stationList.length; i++) {
          if (this.stationList[i].station_id == this.station_value) {
            stationname = this.stationList[i].station_name;
          }
        }
        params.station_name = stationname;
      }
      if (this.charger_value != "") {
        params.charger_id = this.charger_value;
        var chargerName = "";
        this.chargerlist.map((item) => {
          if (item.charger_id == this.charger_value) {
            chargerName = item.charger_name;
          }
        });
        params.charger_name = chargerName;
      }
      if (this.statrttime_value != "" && this.statrttime_value != null) {
        var d = new Date(this.statrttime_value);

        let start_date = d.getFullYear() + "-" + this.checkTime(d.getMonth() + 1) + "-" + this.checkTime(d.getDate()) + " " + this.checkTime(d.getHours()) + ":" + this.checkTime(d.getMinutes()) + ":" + this.checkTime(d.getSeconds());
        // //最后显示yyyy-MM-dd hh:mm:ss
        // params.start_date = start_date.slice(0, 10);
        params.start_time = start_date;
      }
      if (this.endtime_value != "" && this.endtime_value != null) {
        var d1 = new Date(this.endtime_value);
        let end_date = d1.getFullYear() + "-" + this.checkTime(d1.getMonth() + 1) + "-" + this.checkTime(d1.getDate()) + " " + this.checkTime(d1.getHours()) + ":" + this.checkTime(d1.getMinutes()) + ":" + this.checkTime(d1.getSeconds());
        // //最后显示yyyy-MM-dd hh:mm:ss
        // params.end_date = end_date.slice(0, 10);
        params.end_time = end_date;
      }

      if (this.ChStatus_value != "") {
        params.status = this.ChStatus_value;
      }
      if (this.Chtype_value != "") {
        params.pay_type = this.Chtype_value;
      }
      if (this.orderid_input != "") {
        params.keyword = this.orderid_input;
      }

      this.$api({
        method: "post",
        url: "/api.php/ChargeRecord/explode_records",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.linkurl = su.data.url;
            this.createAndDownloadFile(su.data.url);
          } else if (su.data.code == 300) {
            //登录过期
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 302) {
            //数据库出错,导出失败
            this.$message.warning("导出失败");
          } else if (su.data.code == 303) {
            //查询月份不能横跨超过1个月
            this.$message.warning(su.data.message);
          } else if (su.data.code == 304) {
            //没有可导出记录
            this.$message.warning(su.data.message);
          }
})
        .catch((err) => {});
    },
   
  },
};
</script>

<style scoped lang="scss">
.recordData-time {
  width: 98%;
  margin: 1%;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #0071bd;
    border-color: #0071bd;
    color: #fff;
  }

  .el-dialog {
    .el-dialog__header{
      display: none;
    }
    div {
      margin-bottom: 20px;
      text-align: left;
      p {
        display: inline;
        font-size: 18px;
        font-weight: bold;
        color: black;
        margin-bottom: 10px;
      }
    }
  }
}


  /* 退款失败重试对话框样式 */
  .refund-failed-dialog {
    .el-dialog {
      width: 420px !important;
      min-width: 420px !important;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      overflow: hidden;
    }
    
    .el-dialog__header {
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
      border-radius: 12px 12px 0 0;
      padding: 16px 24px;
      margin: 0;
    }
    
    .el-dialog__title {
      color: white;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
    
    .el-dialog__headerbtn {
      top: 16px;
      right: 24px;
    }
    
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
      font-size: 18px;
    }
    
    .el-dialog__body {
      padding: 24px;
    }
    
    .refund-failed-content {
      .warning-info {
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        border: 1px solid #fbbf24;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;
        
        .el-icon-warning {
          font-size: 24px;
          color: #d97706;
          margin-right: 12px;
        }
        
        .warning-text {
          .warning-title {
            font-size: 16px;
            color: #92400e;
            font-weight: 600;
            margin-bottom: 4px;
          }
          
          .warning-desc {
            font-size: 14px;
            color: #92400e;
            opacity: 0.8;
          }
        }
      }
.transaction-info {
        background: #f8fafc;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 16px;
        
        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          
          &:last-child {
            margin-bottom: 0;
          }
          
          .info-label {
            font-size: 14px;
            color: #64748b;
            font-weight: 500;
          }
          
          .info-value {
            font-size: 14px;
            color: #1e293b;
            font-weight: 600;
          }
        }
      }
      .retry-tip {
        display: flex;
        align-items: center;
        background: #f0f9ff;
        border: 1px solid #bae6fd;
        border-radius: 6px;
        padding: 12px;
        
        .el-icon-info {
          font-size: 16px;
          color: #0369a1;
          margin-right: 8px;
        }
        
        span {
          font-size: 14px;
          color: #0369a1;
        }
      }
    }
    
    .dialog-footer {
      .el-button {
        border-radius: 6px;
        padding: 8px 20px;
        
        &.el-button--primary {
          background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
          border: none;
          
          &:hover {
            background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
          }
        }
      }
    }
  }


.topview {
  height: 60px;
  color: #0071bd;
  background-color: white;
  text-align: left;
  span {
    margin-left: 13px;
    line-height: 60px;
    font-weight: bold;
  }
}
.lowerview {
  overflow: hidden;
  clear: both;
  background-color: white;
  margin-top: 10px;
  // padding: 1%;
  // padding-top: 15px;
}
.centerview {
  padding: 1%;
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    float: left;
    margin: 5px 5px 5px 0;
  }
  .allkeyword {
    width: 240px;
  }
}

.querybutton {
  width: 80px;
  height: 35px;
  background-color: #0071bd;
  color: white;
  display: inline-block;
  text-align: center;
  border: none;
  padding: 0;
}
.querybutton:active {
  background-color: #409eff;
}
.recordData-time {
  .search:active {
    background-color: #409eff;
  }
}
.exportbutton {
  width: 80px;
  height: 35px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
  padding: 0;
}
.exportbutton.active {
  background-color: #a5a5a5;
}
.exportbutton.active:hover {
  background-color: #a5a5a5;
}
.bottomviewtwo {
  padding: 1%;
  margin-top: 15px;
  .btn01 {
    color: #0061ae;
  }
  .btn02 {
    color: #e60000;
  }
  .btn03 {
    color: #009a5b;
  }
  .btn04 {
    color: #e9c15b;
  }
  .btn05 {
    color: #999999;
  }
}

.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}
.el-dialog {
  width: 55%;
  min-width: 1000px;
}

h1,
h2 {
  font-weight: normal;
  color: #fff;
}

a {
  color: #42b983;
}

// @media screen and(max-width:1900px) {
//   .recordData-time {
//     .centerview {
//       ul {
//         .allkeyword {
//           width: 30%;
//         }
//       }
//     }
//   }
// }
// @media screen and(max-width:1460px) {
//   .recordData-time {
//     .centerview {
//       ul {
//         .allkeyword {
//           width: 40%;
//         }
//       }
//     }
//   }
// }
// @media screen and(max-width:1420px) {
//   .recordData-time {
//     .centerview {
//       ul {
//         .allkeyword {
//           width: 45%;
//         }
//       }
//     }
//   }
// }
</style>
<style lang="scss">
.recordData-time {
  .bottomviewtwo {
    .el-table tbody tr:hover > td {
      background-color: #f3f3f3 !important;
      color: black;
    }
  }
  .el-dialog {
    width: 55%;
    min-width: 1000px;
}
  
  /* 优化退款对话框样式 */
  .refund-dialog {
    .el-dialog {
      width: 420px !important;
      min-width: 420px !important;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      overflow: hidden;
    }
    
    .el-dialog__header {
      background: linear-gradient(135deg, #005a9e 0%, #0071bd 100%);
      border-radius: 12px 12px 0 0;
      padding: 16px 24px;
      margin: 0;
    }
    
    .el-dialog__title {
      color: white;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
    
    .el-dialog__headerbtn {
      top: 16px;
      right: 24px;
    }
    
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
      font-size: 18px;
    }
    
    .el-dialog__body {
      padding: 24px;
    }
    
    .refund-dialog-content {
      .amount-info {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;
        border: 1px solid #e2e8f0;
        
        .el-icon-wallet {
          font-size: 20px;
          color: #0071bd;
          margin-right: 8px;
        }
        
        .amount-label {
          font-size: 14px;
          color: #64748b;
          font-weight: 500;
        }
        
        .amount-value {
          font-size: 18px;
          color: #0071bd;
          font-weight: 600;
          margin-left: 4px;
        }
      }
      
      .refund-options {
        .option-title {
          font-size: 14px;
          color: #475569;
          font-weight: 500;
          margin-bottom: 16px;
        }
        
        .refund-radio-group {
          width: 100%;
          
          .refund-option {
            width: 100%;
            margin-bottom: 12px;
            padding: 0;
            
            .el-radio__input {
              display: none;
            }
            
            .el-radio__label {
              padding: 0;
              width: 100%;
            }
            
            .option-content {
              display: flex;
              align-items: flex-start;
              padding: 16px;
              border: 2px solid #e2e8f0;
              border-radius: 8px;
              transition: all 0.3s ease;
              cursor: pointer;
              position: relative;
              
              &:hover {
                border-color: #0071bd;
                background-color: #f8fafc;
              }
              
              i {
                font-size: 20px;
                color: #94a3b8;
                margin-right: 12px;
                margin-top: 2px;
                transition: color 0.3s ease;
              }
              
              .option-text {
                flex: 1;
                
                .option-main {
                  font-size: 14px;
                  color: #1e293b;
                  font-weight: 500;
                  margin-bottom: 4px;
                }
                
                .option-desc {
                  font-size: 12px;
                  color: #64748b;
                }
                
                .custom-input-section {
                  margin-top: 12px;
                  
                  .custom-amount-input {
                    width: 180px;
                    
                    .el-input-group__prepend {
                      background-color: #f1f5f9;
                      color: #475569;
                      border-color: #e2e8f0;
                    }
                    
                    .el-input__inner {
                      border-color: #e2e8f0;
                      
                      &:focus {
                        border-color: #0071bd;
                      }
                    }
                  }
                  
                  .error-tip {
                    font-size: 12px;
                    color: #ef4444;
                    margin-top: 4px;
                  }
                  
                  .hint-tip {
                    font-size: 12px;
                    color: #64748b;
                    margin-top: 4px;
                  }
                }
              }
            }
          }
          
          .el-radio.is-checked {
            .option-content {
              border-color: #005a9e;
              background-color: #f0f9ff;
              
              i {
                color: #005a9e;
              }
              
              &::before {
                content: "✓";
                position: absolute;
                top: 8px;
                right: 8px;
                width: 20px;
                height: 20px;
                background: #005a9e;
                color: white;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                font-weight: bold;
                box-shadow: 0 2px 4px rgba(0, 90, 158, 0.3);
              }
            }
          }
        }
      }
    }
    
    .el-dialog__footer {
      padding: 16px 24px 24px;
      text-align: center;
      border-top: 1px solid #f1f5f9;
      
      .el-button {
        min-width: 80px;
        margin: 0 8px;
        border-radius: 6px;
        font-weight: 500;
        transition: all 0.3s ease;
        
        &.el-button--primary {
          background: linear-gradient(135deg, #005a9e 0%, #0071bd 100%);
          border: none;
          
          &:hover:not(.is-disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 90, 158, 0.4);
          }
          
          &.is-disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
        
        &.el-button--default {
          border-color: #cbd5e1;
          color: #64748b;
          
          &:hover {
            border-color: #0071bd;
            color: #0071bd;
          }
}
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalysis/rechargeRecordData.vue
<style scoped>
/* 退款失败对话框样式优化 */
.refund-failed-dialog .el-dialog {
  width: 480px !important;
  min-width: 480px !important;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.refund-failed-dialog .el-dialog__header {
  background: linear-gradient(135deg, #fa8c16 0%, #ffa940 100%);
  border-radius: 12px 12px 0 0;
  padding: 20px 24px;
  margin: 0;
}

.refund-failed-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.refund-failed-dialog .el-dialog__body {
  padding: 24px;
}

.warning-header {
  margin-bottom: 24px;
}

.warning-icon-text {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #fff8e6 0%, #fff2cc 100%);
  border: 1px solid #ffd591;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(250, 140, 22, 0.1);
}

.warning-icon {
  font-size: 28px;
  color: #fa8c16;
  margin-top: 2px;
  flex-shrink: 0;
}

.warning-main {
  flex: 1;
}

.warning-title {
  font-size: 16px;
  font-weight: 600;
  color: #fa8c16;
  margin-bottom: 8px;
  line-height: 1.4;
  letter-spacing: 0.5px;
}

.warning-desc {
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.6;
  letter-spacing: 0.3px;
}

.transaction-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0;
  margin: 20px 0;
  border: 1px solid #e8e8e8;
  overflow: hidden;
}

.info-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #f0f2f5;
  border-bottom: 1px solid #e8e8e8;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.info-icon {
  color: #0071bd;
  font-size: 16px;
}

.info-items {
  padding: 16px 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.info-label {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

.info-value {
  color: #333;
  font-weight: 600;
  font-size: 14px;
}

.retry-tip {
  margin-top: 20px;
}

.tip-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #e6f7ff 0%, #f0fdff 100%);
  border: 1px solid #91d5ff;
  border-radius: 8px;
}

.tip-icon {
  color: #1890ff;
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.tip-text {
  flex: 1;
}

.tip-title {
  font-size: 14px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 4px;
}

.tip-desc {
  font-size: 13px;
  color: #52a9ff;
  line-height: 1.5;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px 24px;
  border-top: 1px solid #e8e8e8;
  background: #fafafa;
}

.cancel-btn {
  min-width: 100px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  color: #666;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  border-color: #0071bd;
  color: #0071bd;
  transform: translateY(-1px);
}

.retry-btn {
  min-width: 100px;
  border-radius: 6px;
  background: linear-gradient(135deg, #fa8c16 0%, #ffa940 100%);
  border: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.retry-btn:hover:not(.is-disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(250, 140, 22, 0.4);
}

.refund-dialog >>> .el-dialog__header {
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.refund-dialog >>> .el-dialog__title {
  color: #333;
  font-weight: 600;
}

.warning-header {
  margin-bottom: 20px;
}

.warning-icon-text {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #fff8e6;
  border: 1px solid #ffd591;
  border-radius: 6px;
}

.warning-icon {
  font-size: 24px;
  color: #fa8c16;
  margin-top: 2px;
  flex-shrink: 0;
}

.warning-main {
  flex: 1;
}

.warning-title {
  font-size: 16px;
  font-weight: 600;
  color: #fa8c16;
  margin-bottom: 4px;
  line-height: 1.4;
}

.warning-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.transaction-info {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  color: #666;
  font-size: 14px;
}

.info-value {
  color: #333;
  font-weight: 500;
  font-size: 14px;
}

.retry-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 6px;
  margin-top: 16px;
}

.tip-icon {
  color: #1890ff;
  font-size: 16px;
  flex-shrink: 0;
}

.tip-text {
  color: #1890ff;
  font-size: 14px;
  line-height: 1.4;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}

/* 修复退款对话框样式 - 使用标准CSS语法 */
.refund-dialog .el-dialog {
  width: 420px !important;
  min-width: 420px !important;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.refund-dialog .el-dialog__header {
  background: linear-gradient(135deg, #005a9e 0%, #0071bd 100%);
  border-radius: 12px 12px 0 0;
  padding: 16px 24px;
  margin: 0;
}

.refund-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.refund-dialog .el-dialog__headerbtn {
  top: 16px;
  right: 24px;
}

.refund-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 18px;
}

.refund-dialog .el-dialog__body {
  padding: 24px;
}

.refund-dialog .amount-info {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid #e2e8f0;
}

.refund-dialog .amount-info .el-icon-wallet {
  font-size: 20px;
  color: #0071bd;
  margin-right: 8px;
}

.refund-dialog .amount-info .amount-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.refund-dialog .amount-info .amount-value {
  font-size: 18px;
  color: #0071bd;
  font-weight: 600;
  margin-left: 4px;
}

.refund-dialog .option-title {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  margin-bottom: 16px;
}

.refund-dialog .refund-radio-group {
  width: 100%;
}

.refund-dialog .refund-option {
  width: 100%;
  margin-bottom: 12px;
  padding: 0;
}

.refund-dialog .refund-option .el-radio__input {
  display: none;
}

.refund-dialog .refund-option .el-radio__label {
  padding: 0;
  width: 100%;
}

.refund-dialog .option-content {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.refund-dialog .option-content:hover {
  border-color: #0071bd;
  background-color: #f8fafc;
}

.refund-dialog .option-content i {
  font-size: 20px;
  color: #94a3b8;
  margin-right: 12px;
  margin-top: 2px;
  transition: color 0.3s ease;
}

.refund-dialog .option-text {
  flex: 1;
}

.refund-dialog .option-main {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  margin-bottom: 4px;
}

.refund-dialog .option-desc {
  font-size: 12px;
  color: #64748b;
}

.refund-dialog .custom-input-section {
  margin-top: 12px;
}

.refund-dialog .custom-amount-input {
  width: 180px;
}

.refund-dialog .custom-amount-input .el-input-group__prepend {
  background-color: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
}

.refund-dialog .custom-amount-input .el-input__inner {
  border-color: #e2e8f0;
}

.refund-dialog .custom-amount-input .el-input__inner:focus {
  border-color: #0071bd;
}

.refund-dialog .error-tip {
  font-size: 12px;
  color: #ef4444;
  margin-top: 4px;
}

.refund-dialog .hint-tip {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

.refund-dialog .el-radio.is-checked .option-content {
  border-color: #005a9e;
  background-color: #f0f9ff;
}

.refund-dialog .el-radio.is-checked .option-content i {
  color: #005a9e;
}

.refund-dialog .el-radio.is-checked .option-content::before {
  content: "✓";
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background: #005a9e;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 90, 158, 0.3);
}

.refund-dialog .el-dialog__footer {
  padding: 16px 24px 24px;
  text-align: center;
  border-top: 1px solid #f1f5f9;
}

.refund-dialog .el-button {
  min-width: 80px;
  margin: 0 8px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.refund-dialog .el-button.el-button--primary {
  background: linear-gradient(135deg, #005a9e 0%, #0071bd 100%);
  border: none;
}

.refund-dialog .el-button.el-button--primary:hover:not(.is-disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 90, 158, 0.4);
}

.refund-dialog .el-button.el-button--primary.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.refund-dialog .el-button.el-button--default {
  border-color: #cbd5e1;
  color: #64748b;
}

.refund-dialog .el-button.el-button--default:hover {
  border-color: #0071bd;
  color: #0071bd;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalysis/rechargeRecordData.vue